'use strict';

const h = require('phy');

const VariablePricingNew = props => {
  const {
    pricingMetadata: { offerLabelDescriptive },
    regularPrice: { formattedAmount },
  } = props;

  return h(
    '.variable-pricing-new',
    h('span.variable-pricing-new-text', offerLabelDescriptive),
    h('span.variable-pricing-new-price', formattedAmount)
  );
};

module.exports = VariablePricingNew;
